import { useEffect, useState } from "react";
import api from "../api/api";
import Loader from "../shared/loader";
import stringHelpers from "../../utilities/stringHelpers";
import { useHistory, useParams, Link } from "react-router-dom";
import { toInputFieldDateString } from "../../utilities/dateUtilities";
import _enum from "../../utilities/enum";

export default function AddEditNotification(props) {
    const history = useHistory();
    const { notificationId } = useParams()
    const [message, setMessage] = useState(null);
    const [notificationType, setNotificationType] = useState("");
    const [expiryDate, setExpiryDate] = useState(null);
    const [allOrganisations, setAllOrganisations] = useState(null);
    const [selectedOrganisations, setSelectedOrganisations] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
    const [canSubmit, setCanSubmit] = useState(false);

    const fetchAllOrganisations = () => {
        setIsLoading(true);
        api.getOrganisations(
            data => {
                setAllOrganisations(data);
                if (!stringHelpers.isNullOrEmpty(notificationId)) {
                    api.getNotifications(
                        result => {
                            const notification = result.find(item => item.id === notificationId);
                            if (notification) {
                                setMessage(notification.message);
                                setNotificationType(String(notification.notificationType));
                                setSelectedOrganisations(notification.organisationIds)
                                setExpiryDate(notification.expiryDate)
                            }
                            if (notification.organisationIds.length === data.length) setIsSelectAllChecked(true)
                        },
                        error => {
                            setIsLoading(false);
                            console.log(error);
                        },
                        props.token
                    );
                }
                setIsLoading(false)
            },
            error => {
                console.log(error);
                setIsLoading(false)
            },
            props.token
        )
    }
    const handleSubmit = () => {
        if (!stringHelpers.isNullOrEmpty(notificationId)) {
            api.editNotification(
                notificationId, message, parseInt(notificationType), selectedOrganisations.length > 0 ? selectedOrganisations : null, stringHelpers.isNullOrEmpty(expiryDate) ? null : expiryDate,
                () => history.push("/notifications"),
                error => console.log(error),
                props.token
            )
        }
        else {
            api.addNotification(
                message, parseInt(notificationType), selectedOrganisations.length > 0 ? selectedOrganisations : null, stringHelpers.isNullOrEmpty(expiryDate) ? null : expiryDate,
                () => history.push("/notifications"),
                error => console.log(error),
                props.token
            )
        }
    }

    const handleSelectionUpdate = (e, organisation) => {
        if (e.target.checked) {
            setSelectedOrganisations(prevState => [...prevState, organisation.id])
            if (allOrganisations.length - selectedOrganisations.length === 1) {
                setIsSelectAllChecked(true)
            }
        } else if (!e.target.checked) {
            const index = selectedOrganisations.findIndex(item => item === organisation.id)
            setSelectedOrganisations(prevState => prevState.toSpliced(index, 1))

            if (isSelectAllChecked) {
                setIsSelectAllChecked(false)
            }
        }
    }

    const handleSelectAll = (e) => {
        setIsSelectAllChecked(!isSelectAllChecked)
        if (e.target.checked) {
            setSelectedOrganisations(allOrganisations.map(item => item.id))
        } else if (!e.target.checked) {
            setSelectedOrganisations([])
        }
    }

    useEffect(() => fetchAllOrganisations(), [])

    useEffect(() => setCanSubmit(!stringHelpers.isNullOrEmpty(notificationType) && !stringHelpers.isNullOrEmpty(message)), [message, notificationType])

    return (
        <>
            {
                isLoading
                    ? <Loader />
                    : <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card mb-3">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <h5 className="mb-0">{ !stringHelpers.isNullOrEmpty(notificationId) ? "Edit" : "Add" } Notification</h5>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-body bg-light border-top details-container">
                                        <div className="row">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-3">Message<span className="req"></span></p>
                                            </div>
                                            <div className="col-md-6 col-12 px-0">
                                                <div className="form-group">
                                                    <textarea rows="5" className="form-control form-control-sm mb-0" type="text" value={ message } onChange={ (e) => setMessage(e.target.value) } />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-3">Type<span className="req"></span></p>
                                            </div>
                                            <div className="col-md-6 col-12 px-0">
                                                <select
                                                    class="border rounded px-2 form-control form-control-sm"
                                                    onChange={ (e) => setNotificationType(e.target.value) }
                                                    value={ notificationType }
                                                >
                                                    <option value="">Select a notification type</option>
                                                    {
                                                        Object.entries(_enum.NotificationType).map(([key, value]) => <option value={ key } key={ key }>{ value }</option>)
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-3">Expiry Date</p>
                                            </div>
                                            <div className="col-md-6 col-12 px-0">
                                                <div className="d-flex align-items-center">
                                                    <input
                                                        className="form-control form-control-sm"
                                                        type="date"
                                                        value={ expiryDate ? toInputFieldDateString(expiryDate) : "" }
                                                        onChange={ e => setExpiryDate(e.target.value) }
                                                    />
                                                    <button onClick={ () => setExpiryDate("") } className="fa fa-times btn p-0 ml-3"></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-3 col-12">
                                                <p className="font-weight-semi-bold mb-3">Organisations</p>
                                            </div>
                                            <div className="col-md-6 col-12 px-0">
                                                <div class="form-check p-0 d-flex align-items-center mb-2">
                                                    <input name="select-all" class="form-check-input position-static m-0" id="select-all-organisations" value={ isSelectAllChecked } checked={ isSelectAllChecked } type="checkbox" onChange={ e => handleSelectAll(e) } />
                                                    <label class="form-check-label ml-2" for="select-all-organisations">All</label>
                                                </div>
                                                {
                                                    allOrganisations && allOrganisations.length > 0 && allOrganisations
                                                        .map(item => <div class="form-check p-0 d-flex align-items-center mb-2" key={ item.id }>
                                                            <input onChange={ (e) => handleSelectionUpdate(e, item) } class="form-check-input position-static m-0" id={ item.id } type="checkbox" checked={ selectedOrganisations?.includes(item.id) } value={ item.id } />
                                                            <label class="form-check-label ml-2" for={ item.id }>{ item.name }</label>
                                                        </div>)
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer border-top ">
                                        <div className="row">
                                            <div className="col-6 col-sm-auto ml-auto pl-0">
                                                <div id="dashboard-actions">
                                                    <Link to="/notifications" className="btn btn-falcon-default btn-sm" type="button"><i className="fas fa-times"></i> Cancel</Link>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btn-sm ml-2"
                                                        disabled={ !canSubmit }
                                                        onClick={ () => handleSubmit() }>
                                                        <i className="fas fa-check"></i> Confirm
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}